import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Endpoint:'',
        User:'',
        AccessToken:'',
        IdToken:'',
        Attributes:''
    },
    mutations: {
        setEndpoint:function(state,endpoint){
            state.Endpoint = endpoint
            localStorage.setItem('Endpoint',endpoint)
        },
        setUser:function(state,user){
            state.User = user
            localStorage.setItem('User',user)
        },
        setAccessToken:function(state,AccessToken){
            state.AccessToken = AccessToken
            localStorage.setItem('AccessToken',AccessToken)
        },
        setIdToken:function(state,IdToken){
            state.IdToken = IdToken
            localStorage.setItem('IdToken',IdToken)
        },
        setAttributes:function(state,Attributes){
            state.Attributes = Attributes
            localStorage.setItem('Attributes',Attributes)
        }
    }
})